import React from 'react'
import FetchComponent from '../../commons/fetch/FetchComponent'
import { fetchClear } from '../../commons/fetch/FetchComponent/actions'
import FormReducer from '../../commons/FormReducer'
import { formFieldsValue } from '../../commons/FormReducer/action'
import actionTarget from '../../commons/Redux/actionTarget'
import View from './view'

export class TestFetch extends React.Component {

    constructor(props) {
        super(props)
        this.onClickTestGet = this.onClickTestGet.bind(this)
        this.onClickTestEntity = this.onClickTestEntity.bind(this)
        this.onClickReset = this.onClickReset.bind(this)
    }

    componentDidUpdate(prevProps) {
        const {
            action,
            dispatch,
            storeTargetFetched
        } = this.props
        if (prevProps.action !== action && action === 'reset') {
            dispatch(actionTarget(fetchClear(), storeTargetFetched))
        }
    }

    onClickTestGet() {
        console.log('test-get')
        this.onClick('test-get')
    }

    onClickTestEntity() {
        console.log('test-entity')
        this.onClick('test-entity')
    }

    onClickReset() {
        console.log('reset')
        this.onClick('reset')
    }

    onClick(action) {
        const {
            dispatch,
            storeTargetForm
        } = this.props
        dispatch(actionTarget(formFieldsValue({ action }), storeTargetForm))
    }

    render() {
        const {
            fetchProps,
            storeTargetForm,
            ...props
        } = this.props
        console.log('TestFetch', this.props)
        return (
            <FetchComponent {...fetchProps}>
                <FormReducer storeTarget={storeTargetForm} keepState>
                    <View
                        {...props}
                        onClickTestGet={this.onClickTestGet}
                        onClickTestEntity={this.onClickTestEntity}
                        onClickReset={this.onClickReset}
                    />
                </FormReducer>
            </FetchComponent>
        )
    }
}